export enum VacationRequestStatus {
  OPEN = 'OPEN',
  PARTIAL_DONE = 'PARTIAL_DONE',
  DONE = 'DONE',
  REJECTED = 'REJECTED',
}
